import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { MergeFieldNodeView } from './MergeFieldNodeView';

export interface MergeFieldOptions {
  HTMLAttributes: Record<string, string>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    mergeField: {
      insertMergeField: (key: string, label?: string) => ReturnType;
    };
  }
}

export const MergeFieldExtension = Node.create<MergeFieldOptions>({
  name: 'mergeField',
  group: 'inline',
  inline: true,
  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      key: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-key'),
        renderHTML: (attributes) => ({ 'data-key': attributes.key }),
      },
      label: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-label'),
        renderHTML: (attributes) =>
          attributes.label ? { 'data-label': attributes.label } : {},
      },
      sample: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-sample'),
        renderHTML: (attributes) =>
          attributes.sample ? { 'data-sample': attributes.sample } : {},
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-type="mergeField"]',
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        'data-type': 'mergeField',
        'data-key': node.attrs.key,
      }),
      `{{ ${node.attrs.key} }}`,
    ];
  },

  renderText({ node }) {
    return `{{ ${node.attrs.key} }}`;
  },

  addCommands() {
    return {
      insertMergeField:
        (key: string, label?: string) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: { key, label: label ?? null },
          });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(MergeFieldNodeView);
  },
});
